
h_checkPresaleDate();


function h_checkPresaleDate(){
    var isPreorder = document.querySelector(".pdp-preorder-text").getAttribute("data-ispreorder");
    if(isPreorder == "1"){
        var preorderDate = document.querySelector(".pdp-preorder-text").getAttribute("data-shipby");

        var date = new Date(preorderDate);      
        var date5DaysAway = new Date(Date.now() + 5 * 24 * 60 * 60 * 1000) ;

    
        if(date >= date5DaysAway){      
            document.querySelector(".pdp-preorder-text").classList.remove('hide');
        }
        else{
            document.querySelector("input#property-isPreorder").remove();
            document.querySelector("input#property-PreorderShipDate").remove();
        }
    }
}